/**
 * 4STARS — baner "grafik na nowy sezon wkrótce"
 *
 * Umieść w: src/components/scheduleSoon.jsx
 *
 * Użycie w location.jsx:
 *
 *   const { groups, status, note, seasonLabel } = useSchedule(location);
 *
 *   {status === "loading" && <ScheduleSkeleton color={location?.color} />}
 *   {status === "soon"    && <ScheduleSoon color={location?.color} note={note}
 *                                          seasonLabel={seasonLabel}
 *                                          locationName={location?.name} />}
 *   {status === "published" && <Schedule groups={groups} />}
 *   {status === "hidden"  && null}
 */

import React from "react";
import { Link } from "react-router-dom";

export default function ScheduleSoon({
  color = "#d0142d",
  note,
  seasonLabel,
  locationName,
}) {
  return (
    <section
      style={{
        width: "92%",
        maxWidth: "1200px",
        margin: "30px auto",
        backgroundColor: "rgba(255,255,255,0.94)",
        border: "1px solid rgba(0,0,0,0.08)",
        borderRadius: "22px",
        padding: "28px 24px",
        boxShadow: "0 10px 24px rgba(0,0,0,0.06)",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "14px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* pasek akcentu w kolorze lokalizacji */}
      <span
        aria-hidden="true"
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "6px",
          backgroundColor: color,
        }}
      />

      <span
        style={{
          fontSize: "11px",
          fontWeight: 900,
          letterSpacing: "0.06em",
          color: color,
          backgroundColor: `${color}1a`,
          borderRadius: "999px",
          padding: "6px 12px",
        }}
      >
        W PRZYGOTOWANIU
      </span>

      <h2
        style={{
          margin: 0,
          fontSize: "22px",
          fontWeight: 900,
          color: "rgba(0,0,0,0.92)",
          lineHeight: 1.25,
        }}
      >
        Grafik{seasonLabel ? ` na sezon ${seasonLabel}` : " na nowy sezon"} jeszcze
        przygotowujemy
      </h2>

      <p
        style={{
          margin: 0,
          fontSize: "14px",
          fontWeight: 600,
          color: "rgba(0,0,0,0.65)",
          lineHeight: 1.6,
          maxWidth: "640px",
        }}
      >
        Grafik {locationName ? ` lokalizacji ${locationName}` : ""} 
        {note}
      </p>

      <p
        style={{
          margin: 0,
          fontSize: "13px",
          fontWeight: 600,
          color: "rgba(0,0,0,0.55)",
          lineHeight: 1.6,
          maxWidth: "640px",
        }}
      >
        Zostaw kontakt, a odezwiemy się z propozycją grup dopasowanych do wieku i
        poziomu dziecka.
      </p>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "4px" }}>
        <a
          href="#kontakt"
          style={{
            textDecoration: "none",
            backgroundColor: color,
            color: "rgb(250,250,250)",
            borderRadius: "999px",
            padding: "12px 20px",
            fontSize: "12px",
            fontWeight: 900,
          }}
        >
          Zapytaj o zajęcia
        </a>

        <Link
          to="/lokalizacje"
          style={{
            textDecoration: "none",
            border: "1px solid rgba(0,0,0,0.12)",
            backgroundColor: "rgba(255,255,255,0.95)",
            color: "rgba(0,0,0,0.85)",
            borderRadius: "999px",
            padding: "12px 20px",
            fontSize: "12px",
            fontWeight: 900,
          }}
        >
          Zobacz inne lokalizacje
        </Link>
      </div>
    </section>
  );
}

/** Wersja szkieletowa na czas ładowania — zapobiega mignięciu baneru. */
export function ScheduleSkeleton({ color = "#d0142d" }) {
  return (
    <section
      aria-busy="true"
      aria-label="Wczytywanie grafiku"
      style={{
        width: "92%",
        maxWidth: "1200px",
        margin: "30px auto",
        backgroundColor: "rgba(255,255,255,0.7)",
        border: "1px solid rgba(0,0,0,0.06)",
        borderRadius: "22px",
        padding: "28px 24px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "6px",
          backgroundColor: color,
          opacity: 0.35,
        }}
      />
      {[38, 22, 22].map((h, i) => (
        <span
          key={i}
          aria-hidden="true"
          style={{
            display: "block",
            height: `${h}px`,
            width: i === 0 ? "60%" : i === 1 ? "85%" : "45%",
            borderRadius: "8px",
            backgroundColor: "rgba(0,0,0,0.06)",
          }}
        />
      ))}
    </section>
  );
}
